<template>
    <sui-segment basic>
        <span @click="showCreateModal = true" class="ui right floated primary button">Crear usuario</span>
        <h3 is="sui-header" dividing>Usuarios</h3>
        <sui-tab :active-index.sync="activeIndex">
            <sui-tab-pane v-for="tab in tabs" :key="tab" :title="tab">
                <table class="ui five column selectable table">
                    <thead>
                        <tr>
                            <th>Usuario</th>
                            <th>Correo</th>
                            <th>RFC</th>
                            <th>Celular</th>
                            <th>Activo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr @click="editUser(user.id)" v-for="user in filteredUsers" :key="user.id">
                            <td>{{ user.fullName }}</td>
                            <td>{{ user.email}}</td>
                            <td>{{ user.rfc }}</td>
                            <td>{{ user.cellphone }}</td>
                            <td>{{ user.active ? 'Si' : 'No' }}</td>
                        </tr>
                    </tbody>
                </table>
            </sui-tab-pane>
        </sui-tab>
    <sui-modal size="small" v-model="showCreateModal">
      <sui-modal-header>Crear usuario</sui-modal-header>
      <sui-modal-content>
        <div>
        <sui-form>
              <sui-form-fields fields="two">
            <sui-form-field required>
                <label>Primer nombre</label>
                <input
                    v-model="newUser.firstName"
                />
            </sui-form-field>
            <sui-form-field>
                <label>Segundo nombre</label>
                <input
                    v-model="newUser.middleName"
                />
            </sui-form-field>
        </sui-form-fields>
        <sui-form-fields fields="two">
            <sui-form-field required>
                <label>Apellido Paterno</label>
                <input
                    v-model="newUser.fatherSurname"
                />
            </sui-form-field>

            <sui-form-field required>
                <label>Apellido materno</label>
                <input
                    v-model="newUser.motherSurname"
                />
            </sui-form-field>
        </sui-form-fields>

            <sui-form-fields fields="three">
                <sui-form-field>
                <label>Correo electrónico</label>
                <input placeholder="Ej. correo@blucapital.mx" v-model="newUser.email" />
            </sui-form-field>
                <sui-form-field>
                    <label>Fecha de expiración de usuario</label>
                    <v-date-picker v-model="newUser.expirationDate" :masks="masks">
                        <template v-slot="{ inputValue, inputEvents }">
                            <input class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300" :value="inputValue" v-on="inputEvents" />
                        </template>
                    </v-date-picker>
                </sui-form-field>
                <sui-form-field>
                    <label>¿Es externo?</label>
                    <sui-checkbox v-model="newUser.isExternal" />
                </sui-form-field>
            </sui-form-fields>
        </sui-form>
        </div>
      </sui-modal-content>
      <sui-modal-actions>
        <sui-button primary @click="createUser">
          Crear
        </sui-button>
      </sui-modal-actions>
    </sui-modal>

    </sui-segment>
</template>

<script>
import GenericService from '@/services/GenericService'

export default {
    name: 'Users',
    data () {
        return {
            users: [],
            showCreateModal: false,
            newUser: {},
            loader: undefined,
            masks: { input: 'YYYY/MM/DD' },
            activeIndex: 0,
            tabs: ['Empleados', 'Externos']
        }
    },
    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }

        this.fetchUsers()
    },
    methods: {
        editUser (userId) {
            this.$router.push({ path: `/userDetails/${userId}` })
        },
        async fetchUsers () {
            this.loader = this.$loading.show()
            let { data } = await GenericService.getAll('/users')
            this.users = data.items
            this.loader.hide()
        },
        async createUser () {
            this.loader = this.$loading.show()

            if (!this.newUser.firstName || !this.newUser.fatherSurname || !this.newUser.motherSurname || !this.newUser.email) {
                this.$swal({
                    icon: 'warning',
                    title: 'Datos incompletos',
                    text: 'Debes llenar todos los datos',
                    toast: true,
                    timer: 4000,
                    position: 'top',
                    showConfirmButton: false
                })
                return
            }

            try {
                let response = await GenericService.create('/user', this.newUser)

                if (response) {
                    this.$swal({
                        icon: 'success',
                        title: 'Se agregó el nuevo usuario',
                        text: 'Se mandó un correo al usuario con sus datos de acceso',
                        timer: 4000,
                        showConfirmButton: true
                    }).then(() => {
                        this.showCreateModal = false
                        this.newUser = {}
                        this.fetchUsers()
                    })
                } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Hubo un error',
                        text: 'Hubo un fallo al crear el usuario. Contacta al administrador.',
                        timer: 4000,
                        position: 'top',
                        showConfirmButton: false
                    })
                }
                this.loader.hide()
            } catch (error) {
                const msg = (error.data || {}).message || 'Hubo un fallo al crear el usuario. Contacta al administrador.'
                this.$swal({
                    icon: 'warning',
                    title: 'Hubo un error',
                    text: msg,
                    timer: 4000,
                    position: 'top',
                    showConfirmButton: false
                })
            }
        }
    },
    computed: {
        filteredUsers () {
            return this.users.filter(user => {
                return this.activeIndex === 0 ? !user.isExternal : user.isExternal
            })
        }
    }

}
</script>

<style scoped>

</style>
